// extracted by mini-css-extract-plugin
export default {"banner":"lib-warning_banner-GDPRBanner__banner___MZ8u7","text":"lib-warning_banner-GDPRBanner__text___RfjGz","close":"lib-warning_banner-GDPRBanner__close___SWbzo"};